const RGBRegex = /^rgba?\((?:\s+)?(?<r>\d+(?<unit>%?))(?:\s+)?(?<separator>[\s|,])(?:\s+)?(?<g>\d+\k<unit>)(?:\s+)?\k<separator>(?:\s+)?(?<b>\d+\k<unit>)(?:\s+)?(?:(?:,(?:\s+)?(?<a>(?:\d+)?(?:\.?\d+)))?(?:\s+)?)?\)$/;
/**
 * Function to validate rgb
 * @example
 * import { isValidRGB } from '@design-stack-vista/i18n-color-name';
 *
 * if (isValidRGB('rgb(0, 0, 0)')) {
 *     // write your code here
 * }
 * @param {string} hex
 * @returns {boolean}
 */
export const isValidRGB = (value) => RGBRegex.test(value);
/**
 * Parse the rgb color string and get the value of red, green and blue
 * @example
 * import { getRBGFromString } from '@design-stack-vista/i18n-color-name';
 *
 * const { r, g, b, a, value } = getRBGFromString('rgb(0, 0, 0)');
 * @param {string} code RGB value
 * @return {object}
 */
export const getRBGFromString = (code) => {
    if (!isValidRGB(code)) {
        throw new Error('Invalid RGB value.');
    }
    const matches = code.match(RGBRegex);
    const { a, b, g, r } = matches.groups;
    const result = {
        b: Number(b),
        g: Number(g),
        r: Number(r),
        value: matches.input,
    };
    if (a) {
        result.a = Number(a);
    }
    return result;
};
//# sourceMappingURL=rgb.js.map